import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/Rx';
import { API_URL } from '../../config';

@Injectable()
export class ApiService {

  baseUrl: String;

  constructor(
    public http: HttpClient
  ) {
    this.baseUrl = API_URL + '?trackId=';
  }

  getTrack( trackId ) {
    return this.http.get( this.baseUrl + trackId )
      .map( this.extractData );
  }

  private extractData(res: Response) {
    const body = res;
    return body || { };
  }
}



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/service/api.service.ts